import { css } from "@emotion/css";
import { Tooltip } from "@octopusdeploy/design-system-components";
import { InfoCircleIcon } from "@octopusdeploy/design-system-icons";
import { themeTokens } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
export default function DefaultValueIndicator({ show }: {
    show: boolean;
}) {
    if (!show) {
        return null;
    }
    return (<Tooltip content={"Inherited default value"}>
            <div className={styles.editIcon}>
                <InfoCircleIcon size={24}/>
            </div>
        </Tooltip>);
}
const styles = {
    editIcon: css({
        color: themeTokens.color.icon.tertiary, // Don't attract attention to this icon
    }),
};
